import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { PayrollValidateEmployeeCustomFieldsResponse } from '../types';

// Schema: PayrollValidationResult uses isValid (not valid), and violations have
// field/description/ruleId/ruleName/involvedFields/severity (not fieldKey/message)
const validateMutation = gql`
  mutation PayrollValidateEmployeeCustomFields($userId: ID!, $fields: JSON!) {
    payrollValidateEmployeeCustomFields(userId: $userId, fields: $fields) {
      isValid
      violations {
        field
        description
        ruleId
        ruleName
        involvedFields
        severity
      }
    }
  }
`;

export const validateEmployeeCustomFields = (variables: {
  userId: string;
  fields: Record<string, unknown>;
}) =>
  graphQLApi<
    PayrollValidateEmployeeCustomFieldsResponse,
    { userId: string; fields: Record<string, unknown> }
  >({
    query: validateMutation,
    queryVariables: variables,
  });
